export default __webpack_public_path__ + "static/media/1848.0370ae12.png";